export default {
  "investors.title": "Invest in the future of African tennis",
  "investors.subtitle": "Join the most ambitious sports development project in Central Africa",
  "investors.vision": "A Strategic Vision",
  "investors.visionDesc": "Tennis Club de Douala carries a pioneering vision never seen before in Cameroon, led by President Baby Olivier Pandja.",
  "investors.project1": "ITF-standard court renovation and construction",
  "investors.project1Desc": "Full refurbishment of the 6 existing courts and complex expansion with surfaces meeting international standards. Goal: full ITF certification.",
  "investors.project2": "Certified coach training program",
  "investors.project2Desc": "Creation of a permanent training center with international partnerships. Certification recognized by African and world federations.",
  "investors.project3": "Padel expansion — 2 courts",
  "investors.project3Desc": "Construction of 2 Padel courts, the world's fastest-growing sport. First Padel complex in Cameroon.",
  "investors.project4": "Young Talent Tennis Academy",
  "investors.project4Desc": "Development of an academy to identify and train future Cameroonian champions. Scholarships, housing, schooling, and intensive training.",
  "investors.project5": "Central Africa regional outreach",
  "investors.project5Desc": "Partnerships with African federations, hosting continental tournaments, and positioning as the premier tennis hub.",
  "investors.market": "Market & Opportunity",
  "investors.market1Title": "27M",
  "investors.market1Desc": "Population in Cameroon — rapidly growing middle class",
  "investors.market2Title": "+45%",
  "investors.market2Desc": "Tennis growth in Sub-Saharan Africa over the past 5 years",
  "investors.market3Title": "3x",
  "investors.market3Desc": "Padel — worldwide adoption tripled in the last 5 years",
  "investors.market4Title": "1st",
  "investors.market4Desc": "Tennis-padel sports complex of this scale in Central Africa",
  "investors.cta": "Discuss a Partnership",
  "investors.form.name": "Full Name",
  "investors.form.organization": "Organization",
  "investors.form.email": "Email",
  "investors.form.phone": "Phone",
  "investors.form.interest": "Project of Interest",
  "investors.form.message": "Message",
  "investors.form.cta": "Submit",
  "investors.contact": "Contact us directly: contact@tennisclubdouala.com"
}